<div class="row justify-content-center mb-5">
  <div class="col-12">
    @if (
      showActions &&
      !isAddEvent &&
      isCreator &&
      (campaignStatus === CampaignStatus.PreLive || campaignStatus === CampaignStatus.Live)
    ) {
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <div class="btn btn-green" (click)="addEvent()">
            {{ 'campaign.addNewEvent' | translate }}
          </div>
        </div>
      </div>
    }
    @if (!isAddEvent) {
      <div class="row">
        <div class="col-12">
          <h4 class="font-weight-extrabold">{{ 'campaign.events' | translate }}</h4>
        </div>
      </div>
      <div class="tw-grid tw-gap-4 sm:tw-grid-cols-2">
        @for (event of events; track event) {
          <a
            class="tw-relative tw-rounded tw-border tw-border-divider"
            [href]="event.eventLink"
            target="_blank"
          >
            @if (event?.isUpcoming || event?.isOngoing) {
              <div
                class="tw-absolute tw-left-3 tw-top-1.5 tw-z-[2] tw-rounded-full tw-border-2 tw-border-white tw-px-2 tw-py-1 tw-text-xs tw-uppercase tw-text-white"
                [class.tw-bg-secondary-light]="event?.isOngoing"
                [class.tw-bg-warning]="event?.isUpcoming"
              >
                @if (event.isOngoing) {
                  <i class="fa fa-check tw-mr-1" aria-hidden="true"></i>
                }
                @if (event?.isUpcoming) {
                  <span>{{ 'common.upcoming' | translate }}</span>
                }
                @if (event?.isOngoing) {
                  <span>{{ 'common.ongoing' | translate }}</span>
                }
              </div>
            }
            <div class="tw-aspect-h-9 tw-aspect-w-16">
              @if (event.photoAttachmentUrl) {
                <img
                  class="tw-object-contain"
                  [alt]="event.title"
                  [src]="event.photoAttachmentUrl"
                />
              }
            </div>
            <div class="tw-p-5">
              <div class="tw-text-lg tw-font-bold tw-text-black">
                {{ event.title }}
              </div>
              <div class="tw-text-sm tw-font-medium tw-text-secondary">
                {{ event.startDate | amDateFormat: 'ddd, DD MMM YYYY, hh:mm a' }}
              </div>
              <div class="tw-mt-3 tw-text-body">
                <app-tag-list [tags]="getTags(event.eventTagsArray)"></app-tag-list>
              </div>
              @if (
                showActions &&
                isCreator &&
                (campaignStatus === CampaignStatus.PreLive ||
                  campaignStatus === CampaignStatus.Live)
              ) {
                <div class="action-panel d-flex tw-mt-2.5 tw-justify-end">
                  <div
                    class="pitchin-icon pitchin-icon-edit-black mr-3"
                    (click)="$event.stopPropagation(); $event.preventDefault(); editEvent(event)"
                  ></div>
                  <div
                    class="pitchin-icon pitchin-icon-delete"
                    (click)="
                      $event.stopPropagation(); $event.preventDefault(); deleteEvent(event.id)
                    "
                  ></div>
                </div>
              }
            </div>
          </a>
        }
      </div>
      @if (total - events.length > 0) {
        <div class="col-12 d-flex my-3 p-0">
          <div class="view-more" (click)="loadMore()">
            {{ 'common.loadMore' | translate }}
          </div>
        </div>
      }
      @if (isLoading) {
        <div class="col-lg-8 col-md-10 col-md-12">
          <agmo-loading></agmo-loading>
        </div>
      }
      @if (!isLoading && (!events || events.length == 0)) {
        <div class="col-12 pb-5 text-center">
          <app-empty-state></app-empty-state>
        </div>
      }
    }
    @if (showActions && isAddEvent) {
      <div class="row mb-4">
        <div class="col-12">
          <h4 class="font-weight-extrabold">{{ 'campaign.addNewEvent' | translate }}</h4>
        </div>
      </div>
      @if (form) {
        <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
          <div class="row">
            <div class="col-lg-12 input-panel">
              <div class="input-label">{{ 'campaign.eventTitle' | translate }}*</div>
              <div class="input-field">
                <input
                  class="form-control"
                  formControlName="title"
                  type="text"
                  [placeholder]="'campaign.eventTitlePlaceholder' | translate"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 form-group">
              <div class="input-label">{{ 'campaign.eventDescription' | translate }}</div>
              <textarea
                class="form-control"
                formControlName="eventDescription"
                [placeholder]="'campaign.eventDescriptionPlaceholder' | translate"
              >
              </textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-6 input-panel">
              <div class="input-label">{{ 'campaign.eventStartDate' | translate }}*</div>
              <div class="input-field date-input tw-cursor-pointer" (click)="startDate.open()">
                <input
                  class="form-control"
                  [matDatepicker]="startDate"
                  formControlName="startDate"
                  name="startDate"
                  placeholder="DD/MM/YYYY"
                  [min]="minStartDate"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="startDate" disableRipple>
                  <div class="pitchin-icon pitchin-icon-calendar" matDatepickerToggleIcon></div>
                </mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
              </div>
              @if (form.controls.startDate.errors && showFormError) {
                <div class="error">
                  {{ 'common.incorrectMinYear' | translate: { 'year': 1990 } }}
                </div>
              }
            </div>
            <div class="col-lg-4 col-md-6 input-panel">
              <div class="input-label">{{ 'campaign.eventStartTime' | translate }}*</div>
              <div class="input-field date-input tw-cursor-pointer" (click)="startTime.open()">
                <input
                  [ngxMatTimepicker]="startTime"
                  placeholder="HH:MM"
                  class="form-control"
                  formControlName="startTime"
                  [min]="minTime"
                  readonly
                />
                <span class="owl-date-time-toggle">
                  <div class="pitchin-icon pitchin-icon-clock"></div>
                </span>
                <ngx-mat-timepicker #startTime></ngx-mat-timepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-6 input-panel">
              <div class="input-label">{{ 'campaign.eventEndDate' | translate }}*</div>
              <div
                class="input-field date-input tw-cursor-pointer"
                (click)="form.get('endDate')?.enabled && endDate.open()"
              >
                <input
                  class="form-control"
                  [matDatepicker]="endDate"
                  formControlName="endDate"
                  name="endDate"
                  placeholder="DD/MM/YYYY"
                  [min]="form.value.startDate"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="endDate" disableRipple>
                  <div class="pitchin-icon pitchin-icon-calendar" matDatepickerToggleIcon></div>
                </mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 input-panel">
              <div class="input-label">{{ 'campaign.eventEndTime' | translate }}*</div>
              <div
                class="input-field date-input tw-cursor-pointer"
                (click)="form.get('endTime')?.enabled && endTime.open()"
              >
                <input
                  [ngxMatTimepicker]="endTime"
                  placeholder="HH:MM"
                  class="form-control"
                  formControlName="endTime"
                  readonly
                />
                <span class="owl-date-time-toggle">
                  <div class="pitchin-icon pitchin-icon-clock"></div>
                </span>
                <ngx-mat-timepicker #endTime></ngx-mat-timepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 input-panel">
              <div class="input-label mb-0">{{ 'campaign.eventTags' | translate }}</div>
              <div class="input-desc">{{ 'campaign.eventTagsDescription' | translate }}</div>
              <div class="input-field">
                <mat-chip-list #tagList aria-label="EventTags selection" class="form-control">
                  @for (tag of eventTags; track tag) {
                    <mat-chip
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="remove(tag)"
                    >
                      {{ tag }}
                      @if (removable) {
                        <i class="fa fa-times font-size-regular" matChipRemove></i>
                      }
                    </mat-chip>
                  }
                  <input
                    [placeholder]="'campaign.eventTagsPlaceholder' | translate"
                    [matChipInputFor]="tagList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="add($event)"
                  />
                </mat-chip-list>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 input-panel">
              <div class="input-label">{{ 'campaign.eventImage' | translate }}*</div>
              @if (useAIAutoGenerateImage) {
                <div class="d-flex">
                  <div class="form-check">
                    <input
                      type="radio"
                      id="imageTypeAuto"
                      class="form-check-input"
                      value="auto"
                      formControlName="imageType"
                    />
                    <label for="imageTypeAuto">{{ 'campaign.imageTypeAuto' | translate }}</label>
                  </div>
                  <div class="form-check form-radio">
                    <input
                      type="radio"
                      id="imageTypeCustom"
                      class="form-check-input"
                      value="custom"
                      formControlName="imageType"
                    />
                    <label for="imageTypeCustom">{{
                      'campaign.imageTypeCustom' | translate
                    }}</label>
                  </div>
                </div>
              }
              @if (useAIAutoGenerateImage) {
                <div class="d-flex">
                  @if (form.value.imageType === 'auto') {
                    <div class="mt-2 mb-3">
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="autoGenerateImage()"
                        [disabled]="isImageLoading"
                      >
                        {{ isImageLoading ? 'Generating...' : 'Auto Generate Image' }}
                      </button>
                    </div>
                  }
                </div>
              }
              @if (!isImageLoading) {
                <div class="input-field">
                  @if (
                    !isImageLoading &&
                    !imageUrl &&
                    (form.value.imageType === 'custom' || !useAIAutoGenerateImage)
                  ) {
                    <div
                      class="banner-upload"
                      agmoUploader
                      [accept]="accept"
                      (selectFiles)="selectFile($event)"
                    >
                      <div class="upload-container upload-field d-flex">
                        <div class="align-self-center px-4">
                          <div class="pitchin-icon pitchin-icon-upload"></div>
                          <div class="drop-document">
                            {{ 'company.uploadImage' | translate }}
                          </div>
                          <div class="upload-document-instruction">
                            {{ 'campaign.uploadImageInstruction' | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (imageUrl) {
                    <div class="banner-upload">
                      <div class="upload-container">
                        @if (imageUrl) {
                          <img class="banner-image" [alt]="form.value.title" [src]="imageUrl" />
                        }
                        @if (imageUrl) {
                          <div class="pitchin-icon pitchin-icon-add" (click)="removeImage()"></div>
                        }
                      </div>
                    </div>
                  }
                  @if (isImageLoading) {
                    <agmo-loading></agmo-loading>
                  }
                  @if (showFormError && !imageUrl) {
                    <div class="text-danger">
                      {{ 'common.pleaseUploadDocument' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 input-panel">
              <div class="input-label">{{ 'campaign.eventUrl' | translate }}*</div>
              @if (useAutoGenerateZoomMeeting) {
                <div class="d-flex">
                  <div class="form-check">
                    <input
                      type="radio"
                      id="eventUrlTypeAuto"
                      class="form-check-input"
                      value="auto"
                      formControlName="eventUrlType"
                    />
                    <label for="eventUrlTypeAuto">{{
                      'campaign.eventUrlTypeAuto' | translate
                    }}</label>
                  </div>
                  <div class="form-check form-radio">
                    <input
                      type="radio"
                      id="eventUrlTypeCustom"
                      class="form-check-input"
                      value="custom"
                      formControlName="eventUrlType"
                    />
                    <label for="eventUrlTypeCustom">{{
                      'campaign.eventUrlTypeCustom' | translate
                    }}</label>
                  </div>
                </div>
              }
              @if (useAutoGenerateZoomMeeting) {
                <div>
                  @if (form.get('eventUrlType')?.value === 'auto') {
                    <div class="mt-2">
                      <input
                        class="form-control"
                        formControlName="eventLink"
                        type="text"
                        [placeholder]="'campaign.dummyZoomLinkHint' | translate"
                        readonly
                      />
                    </div>
                  }
                  @if (form.get('eventUrlType')?.value === 'custom') {
                    <div class="mt-2">
                      <input
                        class="form-control"
                        formControlName="eventLink"
                        type="text"
                        placeholder="Enter custom URL"
                      />
                    </div>
                  }
                </div>
              }
              @if (!useAutoGenerateZoomMeeting) {
                <div class="mt-2">
                  <input
                    class="form-control"
                    formControlName="eventLink"
                    type="text"
                    placeholder="Enter custom URL"
                  />
                </div>
              }
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6 input-panel d-flex">
              <div class="btn-cancel" (click)="cancel()">{{ 'common.cancel' | translate }}</div>
            </div>
            <div class="col-6 input-panel text-right">
              <button class="btn btn-green" type="submit">{{ 'common.submit' | translate }}</button>
            </div>
          </div>
        </form>
      }
    }
  </div>
</div>
